import React from "react";
import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { ShieldAlert } from "lucide-react";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" testid="terms-page" icon={ShieldAlert} updated="2026">
      <LegalSection heading="1. Nature of Service">
        <p>mypropertyas.com is an online property classifieds and subscription-based listing platform that connects buyers, tenants, owners, and brokers.</p>
        <p>We charge <strong>non-refundable subscription fees</strong> for listing services. We do <strong>not</strong> take transaction commissions and do <strong>not</strong> act as a real estate agent under the Real Estate (Regulation and Development) Act, 2016 (RERA 2016).</p>
      </LegalSection>

      <LegalSection heading="2. User Obligations">
        <p>By using this platform, users agree that they must <strong>not</strong>:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Upload fraudulent, misleading, or fake listings.</li>
          <li>Advertise fake or inaccurate pricing.</li>
          <li>Post content they are not authorized to publish.</li>
          <li>List under-construction projects without a valid RERA registration.</li>
        </ul>
        <p>Users are solely responsible for the accuracy, legality, ownership, and title of any property they list or transact.</p>
      </LegalSection>

      <LegalSection heading="3. Safe Harbor / Intermediary Immunity">
        <p>mypropertyas.com claims intermediary immunity under <strong>Section 79 of the Information Technology Act, 2000</strong>. We act strictly as an intermediary and do not verify, endorse, own, or guarantee any listing.</p>
        <p>We reserve the right to deactivate or remove any account or listing found violating these terms, <strong>without refund</strong>, and to take appropriate legal action.</p>
      </LegalSection>

      <LegalSection heading="4. No Verification of Listings">
        <p>Verification of ownership, title, documents, pricing, and physical condition is the sole responsibility of the buyer and seller. Prices, dimensions, and details are provided by users and may change without notice. Please conduct independent due diligence before any payment or transaction.</p>
      </LegalSection>
    </LegalLayout>
  );
}
